import { customerApi } from "../api/admin/customer-api";
import { personalShopperApi } from "../api/PersonalShopperApi";
import { virtualLockerApi } from "../api/VirtualLockerApi";

export function resolveProductIntakeApi(intakeScope = "admin") {
  if (intakeScope === "personalShopper") {
    return {
      updateIntake: personalShopperApi.personalShopperProductIntakeUpdate,
      statusChange: personalShopperApi.personalShopperProductStatusChange,
      uploadImages: personalShopperApi.personalShopperProductUploadImages,
      deleteImage: personalShopperApi.personalShopperProductDeleteImage,
      addNote: personalShopperApi.personalShopperAddNoteToProduct,
      getNotes: personalShopperApi.personalShopperGetProductNotes,
    };
  }

  if (intakeScope === "customer") {
    return {
      getNotes: virtualLockerApi.getItemNotes,
    };
  }

  return {
    updateIntake: customerApi.productIntakeUpdate,
    statusChange: customerApi.productStatusChange,
    uploadImages: customerApi.productUploadImages,
    deleteImage: customerApi.productDeleteImage,
    addNote: customerApi.addNoteToProduct,
    getNotes: customerApi.getProductNotes,
  };
}
